import React, { Fragment } from 'react'
import PageHeader from '../PageHeader'
import TextSection from '../TextSection'
import SliderContainer from '../SliderContainer'
import FullWidth from '../FullWidth'

export default class RegularPage extends React.Component {
  getAcfComponent(content, key) {
    const type = content.acf_fc_layout
    switch (type) {
      case 'text_section':
        return <TextSection content={content} key={key} />
      case 'slideshow':
        return (
          <Fragment key={key}>
            <div className="slider-header">
              <h2>{content.title}</h2>
            </div>
            <SliderContainer
              content={content.slides}
              continues={content.slides.length <= 2 ? false : true}
              position="bottom-left"
              padding={false}
              key={key}
            />
          </Fragment>
        )
      case 'full_width':
        return <FullWidth content={content} key={key} />
      default:
        return (
          <div className="no-template" key={key}>
            Could not find section.
          </div>
        )
    }
  }
  render() {
    const content = this.props.content
    return (
      <div className="regular-container">
        {content.thumbnail ? <PageHeader image={content.thumbnail} /> : ''}
        {content.acf.content.map((a, i) => {
          return this.getAcfComponent(a, i)
        })}
      </div>
    )
  }
}
